import React, { FC } from 'react'
import styled from 'styled-components'
import { Box } from '@gassan-ui'

const Item = styled.button<{ active: boolean }>`
  transition: opacity 0.2s ease-in-out;
  width: 120px;
  height: 90px;
  background: #fff;
  display: inline-block;
  opacity: ${p => (p.active ? 0.5 : 1)};
  outline: 0;
  margin-right: 4px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

type Props = {
  sources: string[]
  activeIndex: number
  setIndex: (index: number) => void
}

const Thumbnails: FC<Props> = ({ sources, activeIndex, setIndex }) => {
  return (
    <Box as="nav" display={['none', 'block']}>
      {sources.map((src, index) => (
        <Item key={src} active={index === activeIndex} onClick={() => setIndex(index)}>
          <img src={src} alt="" />
        </Item>
      ))}
    </Box>
  )
}

export default Thumbnails
